window.jQuery = window.$ = require('jquery');
var processInclude = require('base/util');

$(document).ready(function () {
    document.body.style.setProperty('--origin-body-width', document.body.scrollWidth);
    // processInclude(require('base/components/menu'));
    processInclude(require('base/components/cookie'));
    processInclude(require('base/components/consentTracking'));
    // processInclude(require('base/components/footer'));
    // processInclude(require('base/components/miniCart'));
    // processInclude(require('base/components/collapsibleItem'));
    processInclude(require('base/components/search'));
    // processInclude(require('base/components/clientSideValidation'));
    // processInclude(require('base/components/countrySelector'));
    // processInclude(require('base/components/toolTip'));
    // Load from overlay
    processInclude(require('overlay_path/customize'));
});

require('base/thirdParty/bootstrap');
require('base/components/spinner');
